import {createContext, useContext} from "react";
import type {Visibility} from "@/tabletop/visibility/VisibilityModel.ts";

export type GameMasterViewSettings = {
    showPlayerSight: boolean;
    setShowPlayerSight: (value: boolean) => void;
    showHostileSight: boolean;
    setShowHostileSight: (value: boolean) => void;
    gmMaskOpacity: number;
    setGmMaskOpacity: (value: number) => void;
    friendlyVisibility: Visibility;
};

export const GameMasterViewSettingsContext = createContext<GameMasterViewSettings | null>(null);

export function useGameMasterViewSettings(): GameMasterViewSettings {
    const context = useContext(GameMasterViewSettingsContext);
    if (!context) throw new Error("useGameMasterViewSettings must be used within GameMasterViewSettingsProvider");
    return context;
}
